import { useEffect, useState } from "react";

function useClinicId(clinicIdList, clinicCode) {
  const getLocalStorageClinics = () =>
    JSON.parse(localStorage.getItem("clinics"));

  const setLocalStorageClinics = (data) =>
    localStorage.setItem("clinics", JSON.stringify(data));

  const [clinicId, setClinicId] = useState();
  useEffect(() => {
    if (!clinicCode) return;
    if (clinicIdList.length === 0) return;
    const localStorageData = getLocalStorageClinics();

    if (!localStorageData) {
      const clinics = initializeClinics(clinicIdList, clinicCode);
      if (clinics.length === 1) setClinicId(clinics[0].id);
    } else {
      const activeClinic = localStorageData[clinicCode]?.find(
        (clinic) => clinic.isActive
      );
      if (activeClinic) setClinicId(activeClinic.id);
    }
  }, [clinicIdList, clinicCode]);

  const selectClinic = (selectedClinicId) => {
    const updatedClinics = clinicIdList.map((id) => ({
      id,
      isActive: id === selectedClinicId,
    }));
    const updatedData = {
      ...getLocalStorageClinics(),
      [clinicCode]: updatedClinics,
    };
    setLocalStorageClinics(updatedData);
    setClinicId(selectedClinicId);
  };
  return [clinicId, selectClinic];
}

const getLocalStorageClinics = () =>
  JSON.parse(localStorage.getItem("clinics"));

const setLocalStorageClinics = (data) =>
  localStorage.setItem("clinics", JSON.stringify(data));

const initializeClinics = (clinicIds, clinic_code) => {
  const clinics = clinicIds.map((id) => ({
    id,
    isActive: clinicIds.length === 1,
  }));
  const initialData = { ...getLocalStorageClinics(), [clinic_code]: clinics };
  setLocalStorageClinics(initialData);
  return clinics;
};

export default useClinicId;
